// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {Fragment, useState, useRef, useEffect} from 'react';
import cn from 'classnames';
import {use_qs_with_set} from '../../../hola/pub/lib/use_qs';
import styles from './switch_slider.module.less';
import {use_screen} from '../../../hola/pub/lib/screen_util';
import {use_translation_v} from '../../../hola/pub/lib/trans_v';

interface i_item {
    text: string;
    id: string;
    active_color?: string;
}

interface i_switch_slider_props {
    qs_param?: string;
    items: i_item[];
    def_type?: 'shared_dc'|'dedicated_dc'|'isp'|'smart_resi'|'isp_plus';
}

interface i_switch_buttons_props {
    text: string;
    id: string;
    on_click: (target: EventTarget, id: string)=>void;
    ref: any;
    is_active: boolean;
    change_text_color?: boolean;
}

const Switch_buttons = React.forwardRef<HTMLButtonElement,
i_switch_buttons_props>((props, ref)=>{
    const {text, id, on_click, is_active,
        change_text_color} = props;
    const {T} = use_translation_v({no_defaults: true});
    const btn_cls = cn(styles.product_btn,
        {
            [styles.no_hover]: is_active,
            [styles.active_btn]: is_active && change_text_color
        });
    return <Fragment>
      <button className={btn_cls} ref={ref} id={id}
        onClick={e=>on_click(e.target, id)}>
        <T>{text}</T>
      </button>
    </Fragment>;
});

export const Switch_slider = (props: i_switch_slider_props)=>{
    const {items, qs_param, def_type} = props;
    const {qs, set_qs} = use_qs_with_set();
    const {width} = use_screen();
    const active = qs[qs_param] || def_type || items[0].id;
    const [curr_id, set_curr_id] = useState(active);
    const [slide_style, set_slide_style] = useState({});
    const btn_refs = useRef<{[key: string]: HTMLButtonElement | null}>({});
    const is_column = width <= 988 && qs_param == 'type' ? true : false;
    const update_slider_style = (target, id)=>{
        if (!target)
            return;
        let left = width <= 988 ? 4 : 0, top = 8;
        let slider_width = target.offsetWidth;
        const active_item = items.find(i=>i.id==id);
        for (; target.previousSibling;)
        {
            target = target.previousSibling;
            if (is_column)
                top += target.offsetHeight;
            else
                left += target.offsetWidth;
        }
        const style = {
            width: slider_width,
            backgroundColor: active_item?.active_color ||
                'var(--wp--preset--color--neutrals-700)',
        };
        if (is_column)
            style['top'] = top;
        else
            style['left'] = left;
        set_slide_style(style);
    };
    const on_click = (e, id)=>{
        // xxxliviu:set optimistic id to fast hydrate ui let the prop reset it
        set_curr_id(id);
        set_qs({[qs_param]: id});
    };
    useEffect(()=>{
        if (curr_id && Object.keys(btn_refs.current).length
            && btn_refs.current[curr_id])
        {
            const hanlde_resize = ()=>{
                return update_slider_style(btn_refs.current[curr_id], curr_id);
            };
            const resize_observer = new ResizeObserver(hanlde_resize);
            resize_observer.observe(btn_refs.current[curr_id]);
            update_slider_style(btn_refs.current[curr_id], curr_id);
            return ()=>resize_observer.disconnect();
        }
    }, [curr_id, width]);
    return <div className={cn(qs_param=='type' ? styles.type_slider_container :
      styles.period_slider_container)}>
      {items.map((item, i)=>{
        const {text, id} = item;
        return <Switch_buttons text={text} id={id} on_click={on_click}
          key={i} is_active={id==curr_id}
          change_text_color={qs_param=='period'}
          ref={el=>btn_refs.current[id] = el}/>;
        })}
        <div className={styles.buttons_slider} style={slide_style}></div>
    </div>;
};
